import { OptionPriceBasic } from '../../lib/types/models/option-prices/option-price'
import { OptionPriceSuggestionInput } from '../../lib/types/models/option-prices/option-price-input'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getOptionPriceSuggestion({
  optionId,
  ...input
}: OptionPriceSuggestionInput & { optionId: number }) {
  return restApiClient
    .url(
      encodeNestedObject<OptionPriceSuggestionInput>(
        constructApiUrl(API.options.getOptionPriceSuggestion.url, { id: optionId }),
        input
      )
    )
    .get<OptionPriceBasic>()
}
